import React from "react";
import { Box, Typography, Button, Modal, IconButton } from "@material-ui/core";
import { X } from "lucide-react";
import { makeStyles } from "@material-ui/core/styles";
import verifyIcon from "../../assets/images/verify.png";

const useStyles = makeStyles(theme => ({
  modalWrapper: {
    "& .MuiBackdrop-root": {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      zIndex: 1400,
    },
  },
  modalContent: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#131313",
    padding: "0px",
    width: "500px",
    borderRadius: "12px",
    zIndex: 1401,
    boxShadow: "0px 4px 20px rgba(0,0,0,0.5)",
    border: "none",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
    backgroundColor: "#131313",
    borderRadius: "16px",
  },
  content: {
    backgroundColor: "#131313",
    color: "#fff",
    padding: "0 24px 24px 24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderBottomLeftRadius: "16px",
    borderBottomRightRadius: "16px",
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "24px",
  },
  successIcon: {
    width: "80px",
    height: "80px",
    objectFit: "contain",
  },
  title: {
    color: "#ffffff",
    fontSize: "24px",
    fontWeight: 600,
    marginBottom: "12px",
    textAlign: "center",
    fontFamily: "Work Sans, sans-serif",
  },
  description: {
    color: "#cccccc",
    fontSize: "16px",
    lineHeight: "1.5",
    marginBottom: "32px",
    textAlign: "center",
    fontFamily: "Work Sans, sans-serif",
  },
  continueButton: {
    backgroundColor: "#FE5A97",
    color: "#ffffff",
    fontSize: "16px",
    fontWeight: 600,
    padding: "12px 32px",
    borderRadius: "8px",
    textTransform: "none",
    fontFamily: "Work Sans, sans-serif",
    width: "100%",
    "&:hover": {
      backgroundColor: "#fe4a87",
    },
    transition: "all 0.3s ease",
  },
  closeButton: {
    color: "#ffffff",
    padding: "8px",
  },
}));

interface SuccessModalProps {
  open: boolean;
  onClose: () => void;
  onContinue?: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  open,
  onClose,
  onContinue,
}) => {
  const classes = useStyles();

  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      disablePortal
      disableEnforceFocus
      disableScrollLock
      className={classes.modalWrapper}
    >
      <Box className={classes.modalContent}>
        <Box className={classes.header}>
          <Box style={{ width: "40px" }} />
          <IconButton onClick={onClose} className={classes.closeButton}>
            <X size={24} />
          </IconButton>
        </Box>
        <Box className={classes.content}>
          <Box className={classes.iconContainer}>
            <img
              src={verifyIcon}
              alt="Success"
              className={classes.successIcon}
            />
          </Box>
          <Typography className={classes.title}>
            Successful purchase
          </Typography>
          <Typography className={classes.description}>
            Now you can continue enjoying Sugar Cribs content!
          </Typography>
          <Button
            variant="contained"
            className={classes.continueButton}
            onClick={handleContinue}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SuccessModal;

